import React from 'react';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import loading_geoshape from '@assets/animation/loading_icon_geoshapes.json';
import { IStudentExamResultImageFile } from '@models/interfaces/student.interface';

interface ImageAttachmentProps {
  image_files: IStudentExamResultImageFile[];
  setSelectedImage: React.Dispatch<React.SetStateAction<string>>;
  setSelectedImageIndex: React.Dispatch<React.SetStateAction<number>>;
}

const ImageAttachment = ({
  image_files,
  setSelectedImage,
  setSelectedImageIndex,
}: ImageAttachmentProps) => {
  return (
    <>
      {image_files.length < 1 ||
      image_files === null ||
      image_files === undefined ? (
        <div
          className={`attachment-container w-full overflow-x-auto py-3 my-3 whitespace-nowrap shrink-0 text-left`}
        >
          No Images Uploaded
        </div>
      ) : (
        <div
          className={`attachment-container w-full overflow-x-auto py-3 my-3 whitespace-nowrap shrink-0 text-left cursor-zoom-in`}
        >
          {image_files &&
            image_files.map((image, index) => {
              return (
                <div
                  key={image.exam_score_image_id}
                  onClick={
                    image.exam_score_image_id === '-1' && image.image_url === ''
                      ? () => {}
                      : () => {
                          setSelectedImage(image.image_url);
                          setSelectedImageIndex(index);
                        }
                  }
                  className={`attachment-item
                  bg-neutral-eraser rounded-lg relative h-[96px] w-[96px] mr-4 inline-block
                  last:mr-0
                  `}
                >
                  {image.exam_score_image_id === '-1' &&
                  image.image_url === '' ? (
                    <div className="attachment-image peer w-full h-full bg-center bg-no-repeat bg-cover rounded-lg relative">
                      <Player
                        autoplay={true}
                        src={loading_geoshape}
                        loop={true}
                        style={{
                          height: '48px',
                          width: '48px',
                          position: 'absolute',
                          transform: 'translate(50%, 50%)',
                        }}
                      >
                        <Controls visible={false} />
                      </Player>
                    </div>
                  ) : (
                    <div
                      className="attachment-image peer w-full h-full bg-center bg-no-repeat bg-cover rounded-lg"
                      style={{
                        backgroundImage: `url("${image.image_url}")`,
                      }}
                      title={`Exam Score Image ${image.exam_score_image_id}`}
                    ></div>
                  )}
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};

export default ImageAttachment;
